import { forwardRef } from 'react';
import { useTranslation, Text, Icon } from '@weareconceptstudio/core';

//* Styles
import MoveItemStyle from './style';

const MoveItem = forwardRef(({ additional_info, description, title, iconName, className }, ref) => {
	const { translate } = useTranslation();

	return (
		<MoveItemStyle
			ref={ref}
			className={className || ''}
		>
			<div className='wrapper-item'>
				<div className='title-icon'>
					<Text className={'h5'}>{title}</Text>
					{iconName && (
						<Icon
							className={'icon icon-title'}
							name={iconName}
						/>
					)}
				</div>
				<div className='cashback-starting'>
					<Text className={'h5 text-percent-all'}>
						{additional_info.percentage}
						<Text
							className={'wrapper-icon-percent'}
							tag={'span'}
						>
							<Icon
								className={'icon icon-percent'}
								name={'percent'}
							/>
						</Text>

						<Text
							className={'cashBack-text'}
							tag={'span'}
							text={'cashback'}
						/>

						<Text
							className={'p p5 border-color'}
							tag={'span'}
						>
							{'('}
							{translate('muramoney')}
							{')'}
						</Text>
					</Text>
					<Text className={'p4 font-montserrat-arm-medium starting-text'}>
						<Text
							tag={'span'}
							text={'starting'}
						/>
						&nbsp;
						{additional_info.started_price}
						<sup>
							<Icon
								className={'icon icon-dram'}
								name={'dram'}
							/>
						</sup>
					</Text>
				</div>
				<div className='description-wrapper'>
					<Text className={'p p5 description'}>{description}</Text>
				</div>
			</div>
		</MoveItemStyle>
	);
});

export default MoveItem;
